// src/stripe.js
import { loadStripe } from '@stripe/stripe-js';

 const stripePromise = loadStripe('pk_live_NjXppVHEEAmzXchwYVoYsUKz00nR0dBbd9');
//const stripePromise = loadStripe('pk_test_zbXOgmpmC82ItjWJKWJTRwSe00gq3fqdDi');

export default stripePromise;
